import PropTypes from "prop-types";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import { Network } from "@capacitor/network";

import { decrypt, encrypt } from "./companyInfo";

export const getPlatform = () => Capacitor.getPlatform();

export const writeDirectory = async (foldername) => {
	return await Filesystem.mkdir({
		path: foldername,
		directory: Directory.Documents,
		recursive: false,
	});
};

export const readDirectory = async (foldername = "") => {
	return await Filesystem.readdir({
		path: foldername ?? "/",
		directory: Directory.Documents,
	});
};

export const writeFile = async (file, data) => {
	return await Filesystem.writeFile({
		path: file,
		data: encrypt(data),
		directory: Directory.Documents,
		encoding: Encoding.UTF8,
	});
};

export const readFile = async (file) => {
	try {
		let readFileRes = await Filesystem.readFile({
			path: file,
			directory: Directory.Documents,
			encoding: Encoding.UTF8,
		});

		if (readFileRes.data) {
			return JSON.parse(decrypt(readFileRes.data));
		} else {
			return null;
		}
	} catch (error) {
		return null;
	}
};

export const deleteFile = async (file) => {
	return await Filesystem.deleteFile({
		path: file,
		directory: Directory.Documents,
	});
};

export const setFileStorage = async (props) => {
	let foldername = props.foldername;
	let filename = props.filename;
	let data = props.data;
	let override = props.override ?? false;
	let file = `${foldername}/${filename}.txt`;

	let newData = [];

	if (Array.isArray(data)) {
		newData = data;
	} else {
		newData = [data];
	}

	try {
		return await readFile(file).then(async (res) => {
			if (res) {
				if (override) {
					return writeFile(file, JSON.stringify(newData));
				} else {
					let dataArr = res;
					dataArr = dataArr.concat(newData);
					return writeFile(file, JSON.stringify(dataArr));
				}
			} else {
				return writeFile(file, JSON.stringify(newData));
			}
		});
	} catch (error) {
		return readDirectory()
			.then(async (res) => {
				if (res && res.files.length) {
					let findFiles = res.files.find((f) => f.name === foldername);

					if (!findFiles) {
						return writeDirectory(foldername).then((res1) => {
							return writeFile(file, JSON.stringify(newData));
						});
					} else {
						return writeFile(file, JSON.stringify(newData));
					}
				} else {
					return writeDirectory(foldername).then((res1) => {
						return writeFile(file, JSON.stringify(newData));
					});
				}
			})
			.catch(async () => {
				return writeDirectory(foldername).then((res1) => {
					return writeFile(file, JSON.stringify(newData));
				});
			});
	}
};

export const checkPermissions = async () => {
	try {
		return await Filesystem.checkPermissions();
	} catch (e) {
		return e;
	}
};
export const requestPermissions = async () => {
	try {
		return await Filesystem.requestPermissions();
	} catch (e) {
		return e;
	}
};

export const checkNetworkStatus = async () => {
	return await Network.getStatus();
};

export const requestPublicStoragePermissions = async () => {
	checkPermissions().then(async (res) => {
		if (res) {
			if (res.publicStorage !== "granted") {
				return await Filesystem.requestPermissions();
			}
		} else {
			return await Filesystem.requestPermissions();
		}
	});
};

writeDirectory.prototype = {
	foldername: PropTypes.string,
};

readDirectory.prototype = {
	foldername: PropTypes.string,
};

writeFile.prototype = {
	file: PropTypes.string,
	data: PropTypes.any,
};

readFile.prototype = {
	file: PropTypes.string,
};

deleteFile.prototype = {
	file: PropTypes.string,
};

setFileStorage.prototype = {
	foldername: PropTypes.string,
	filename: PropTypes.string,
	data: PropTypes.any,
	override: PropTypes.bool,
};
